import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 2C70B20E-4B20-4CF6-8775-339C1184E032
 * name code-greater-than
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-greater-than.svg
 * tags
 * - Developer / Languages 
 * - Math 
 */
export const CodeGreaterThanIcon = createSvgIcon(<><path d="M10.41,7.41L15,12L10.41,16.6L9,15.18L12.18,12L9,8.82M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z" /></>, 'CodeGreaterThanIcon');
export default CodeGreaterThanIcon